import React, { memo, useCallback } from 'react'
import {
	DialogTitle,
	List,
	ListItem,
	ListItemAvatar,
	Avatar,
	ListItemText,
	Divider,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { useTranslation } from 'react-i18next'

import styles from './styles'
import { buildUserAvatar } from 'utils'
import { useHistory } from 'react-router'
import { useGetArticleTagVotersQuery } from 'graphql/__generated__/graphql'

const useStyles = makeStyles(styles)
//todo this component
export const ArticleTagVoters = memo(({ articleId }: { articleId: string }) => {
	const classes = useStyles()

	const { data } = useGetArticleTagVotersQuery({
		variables: { articleId },
	})
	const filteredTagVoters = data?.activeArticleTagCollection?.edges?.filter(
		articleTagVoter =>
			articleTagVoter.node._ActiveArticleTagToUserCollection?.edges &&
			articleTagVoter.node._ActiveArticleTagToUserCollection.edges
				.length > 0,
	)
	if (!filteredTagVoters?.length) return null
	return (
		<>
			{filteredTagVoters?.map(articleTagVoter => (
				<div key={articleTagVoter?.node?.articleTag?.id}>
					<DialogTitle
						id="responsive-dialog-title"
						className={classes.dialogTitle}
					>
						{articleTagVoter?.node?.articleTag?.title}
					</DialogTitle>
					<Divider
						className={classes.dividerTitle}
						light
						variant="middle"
					/>
					<List className={classes.cardItemWrap}>
						<div className={classes.cardItem}>
							<div className={classes.avatarContent}>
								{articleTagVoter?.node?._ActiveArticleTagToUserCollection?.edges?.map(
									voter => (
										<ArticleTagVoter
											key={voter.node.user.id}
											voter={voter.node}
										/>
									),
								)}
							</div>
						</div>
						<Divider className={classes.dividerTag} flexItem />
					</List>
				</div>
			))}
		</>
	)
})

const ArticleTagVoter = memo(
	({
		voter,
	}: {
		voter: {
			__typename?: '_ActiveArticleTagToUser'
			user: {
				__typename?: 'User'
				id: string
				uid: string
				profileCollection?: {
					__typename?: 'ProfileConnection'
					edges: Array<{
						__typename?: 'ProfileEdge'
						node: {
							__typename?: 'Profile'
							id: string
							firstName: string
							lastName: string
							avatarPath?: string | null
							experienceCollection?: {
								__typename?: 'ExperienceConnection'
								edges: Array<{
									__typename?: 'ExperienceEdge'
									node: {
										__typename?: 'Experience'
										position?: string | null
										company?: string | null
									}
								}>
							} | null
						}
					}>
				} | null
			}
			activeArticleTag: {
				__typename?: 'ActiveArticleTag'
				votes?: number | null
				tag?: string | null
				articleTag?: {
					__typename?: 'ArticleTag'
					id: string
					title: string
				} | null
				article?: {
					__typename?: 'Article'
					id: string
					title?: string | null
					slug?: string | null
				} | null
			}
		}
	}) => {
		const classes = useStyles()
		const history = useHistory()
		const { i18n } = useTranslation()

		const handleListItemClick = useCallback(() => {
			history.push({
				pathname: `/${i18n.language}/people/${voter?.user?.uid}`,
			})
		}, [history, i18n.language, voter])

		return (
			<ListItem
				button
				onClick={handleListItemClick}
				key={voter?.user?.uid + voter?.activeArticleTag.articleTag?.id}
			>
				<ListItemAvatar
					key={
						voter?.user.id + voter?.activeArticleTag.articleTag?.id
					}
				>
					{voter?.user.profileCollection?.edges[0].node.avatarPath ? (
						<div>
							<Avatar
								key={
									voter?.user.id +
									voter?.activeArticleTag.articleTag?.id
								}
								classes={{
									root: classes.profilePicture,
								}}
								src={buildUserAvatar(
									voter?.user?.id,
									voter?.user.profileCollection?.edges[0].node
										.avatarPath,
								)}
							/>
						</div>
					) : (
						<Avatar
							classes={{
								root: classes.profilePicture,
							}}
						/>
					)}
				</ListItemAvatar>
				<div className={classes.details}>
					<ListItemText
						key={
							voter?.user?.uid +
							voter?.activeArticleTag.articleTag?.id
						}
						className={classes.name}
						primary={`${voter?.user.profileCollection?.edges[0].node.firstName} ${voter.user.profileCollection?.edges[0].node.lastName}`}
					/>
					<span className={classes.role}>
						{voter?.user.profileCollection?.edges[0].node
							.experienceCollection?.edges[0].node.company
							? `${voter?.user.profileCollection?.edges[0].node.experienceCollection?.edges[0].node.company}`
							: ' '}
						{'  '}
						{voter?.user.profileCollection?.edges[0].node
							.experienceCollection?.edges[0].node.position
							? `${voter?.user.profileCollection?.edges[0].node.experienceCollection?.edges[0].node.position}`
							: ` `}
					</span>
				</div>
			</ListItem>
		)
	},
)
